import React, { Component } from "react";
import PropTypes from "prop-types";
import { parseMessage, createMarkup, createAnchor } from "../utils/parser";
import ExtraMessage from "./ExtraMessage";
import { getAvatarAlt } from "../utils/avatarAlt";
import { resolveBotAvatar, resolveHumanAvatar, handleBotAvatarError, handleHumanAvatarError } from "../utils/imageDefaults";
import "./message2.css";
import "./message.css";

//import cssOPtion;

class Message extends Component {
  render() {
    return message(this.props);
  }
}

const message = (props) => {
  if (!props.bot || !props.bot.data || !props.bot.data.webchat_settings) {
    return null;
  }
  
  // Handle system messages (like "Connecting with agent....") differently
  if (props.message.sub_type === 'SYSTEM' || props.message.author === 'system') {
    return (
      <li className="system-message" style={{
        textAlign: 'center',
        padding: '10px',
        color: '#999',
        fontSize: '16px',
        fontStyle: 'italic',
        listStyle: 'none'
      }}>
        {props.message.message}
      </li>
    );
  }
  
  let finalDate = "";
  let cName = "even";
  let avatar = props.bot.data.webchat_settings.bot_avatar;
  const urlData = new URL(document.location);
  const paramOption = urlData.searchParams.get("option");
  let lmore = props.lmore;
  const showAncButton = props.message.showAncButton;
  let lmoreClass = "learn-more-date";
  //console.log('lmore is ------------>', props.message);
  if (
    props.bot.data.webchat_widget !== null &&
    undefined !== props.bot.data.webchat_widget.bot_avatar &&
    paramOption === "2"
  )
    avatar = props.bot.data.webchat_widget.bot_avatar;
  avatar = resolveBotAvatar(avatar);
  let author = props.message.author;
  let message = props.message.message;
  let avatarOnError = handleBotAvatarError;
  if (author === "Me") {
    avatar = props.bot.data.webchat_settings.human_avatar;
    if (
      props.bot.data.webchat_widget !== null &&
      undefined !== props.bot.data.webchat_widget.human_avatar &&
      paramOption === "2"
    )
      avatar = props.bot.data.webchat_widget.human_avatar;
    avatar = resolveHumanAvatar(avatar);
    avatarOnError = handleHumanAvatarError;
    cName = "odd";
    lmore = "";
  }
  if (lmore !== "") lmoreClass = "learn-more-date";
  if (!isNaN(author)) {
    //avatar = props.imgSrc
    let operator = props.operators && props.operators.data ? props.operators.data.find(function (element) {
      return element.id === author;
    }) : null;
    //console.log(operator)
    if (operator && operator.profile_img_url) {
      avatar = operator.profile_img_url;
    } else {
      // Fallback to default operator avatar if operator not found
      avatar = props.bot.data.webchat_settings.human_avatar || "/images/avatar-female-1.jpg";
    }
  }
  //console.log(avatar+author)
  let customStyles = props.priStyles;
  if (cName === "odd") {
    customStyles = props.secStyles;
  }
  if (undefined !== props.message.extraChats) {
    return (
      <li className={cName}>
        <div className="chat-image">
          <img alt={getAvatarAlt({ bot: props.bot, operators: props.operators, author })} src={avatar} onError={avatarOnError} />
        </div>
        <div className="chat-body">
          <div className="chat-text" style={customStyles}>
            <p dangerouslySetInnerHTML={createMarkup(message, "")} />
          </div>
          {props.message.extraChats.map((message, index) => (
            //console.log(message)
            <ExtraMessage
              key={message.id}
              extraMessage={message}
              origMessage={props.origMessage}
              dispatchAddMessage={props.dispatchAddMessage}
              dispatchDisableInput={props.dispatchDisableInput}
              dispatchEnableInput={props.dispatchEnableInput}
              handleClick={props.handleClick}
              extraChatsCount={props.message.extraChatsCount}
              currentIndex={index}
              dtime={props.dtime}
              bot={props.bot}
              style={customStyles}
              lmore={lmore}
              showAncButton={showAncButton}
              priStyles={props.priStyles}
              secStyles={props.secStyles}
            />
          ))}
        </div>
      </li>
    );
  } else if (undefined !== message) {
    if (props.message.extraChatsCount < 1) finalDate = props.dtime;
    let messages = { text: "", html: "", orignMessage: "" };
    if (!showAncButton) messages = parseMessage(message, showAncButton);
    if (messages.disableInput) {
      //console.log('disable message');
    }
    if (showAncButton) {
      messages.html = createAnchor(message);
      if (!messages.html) {
        const danglingCtaMatch = message.match(
          /target\s*=\s*"_blank"[^>]*>([^<\n]+)/i
        );
        if (danglingCtaMatch) {
          const ctaLabel = (danglingCtaMatch[1] || "Schedule Appointment").trim();
          const fallbackHrefMatch = (lmore || "").match(/href="([^"]+)"/i);
          if (fallbackHrefMatch && fallbackHrefMatch[1]) {
            messages.html = `<a href="${fallbackHrefMatch[1]}" target="_blank">${ctaLabel}</a>`;
          }
        }
      }
      const messageWithoutAnchor = message
        .replace(/<a\b[\s\S]*?<\/a>/i, "")
        .replace(/(?<!["'=])(https?:\/\/[^\s"<>]+)\s*"\s*[^>]*>[^<\n]+/i, "")
        .replace(/target\s*=\s*"_blank"[^>]*>[^<\n]+/i, "")
        .trim();
      messages.orignMessage = messageWithoutAnchor;
      messages.text = messageWithoutAnchor;
    }
    if (messages.html === "") {
      if (props.bot.cssTheme === "option2") {
        //console.log(customStyles);
        return (
          <li className={cName}>
            <div className="chat-image">
              <img alt={getAvatarAlt({ bot: props.bot, operators: props.operators, author })} src={avatar} onError={avatarOnError} />
            </div>
            <div className="chat-body">
              <div class="date-div">
                <div className="chat-text " style={customStyles}>
                  <p
                    dangerouslySetInnerHTML={createMarkup(
                      messages.orignMessage,
                      customStyles
                    )}
                  />
                </div>
                <div className={lmoreClass}>
                  {messages.showCancelLink ? (
                    <span>
                      <button onClick={props.handleClick} type="button" style={{background: 'none', border: 'none', color: 'inherit', textDecoration: 'underline', cursor: 'pointer', padding: 0}}>
                        Never Mind
                      </button>
                      &nbsp;
                    </span>
                  ) : (
                    ""
                  )}
                  {lmore !== "" ? (
                    <span dangerouslySetInnerHTML={createMarkup(lmore, "")} />
                  ) : (
                    ""
                  )}
                  {finalDate}
                </div>
              </div>
            </div>
          </li>
        );
      } else {
        //console.log("date-div 4");
        return (
          <li className={cName}>
            <div className="chat-image">
              <img alt={getAvatarAlt({ bot: props.bot, operators: props.operators, author })} src={avatar} onError={avatarOnError} />
            </div>
            <div className="chat-body">
              <div className="chat-text date-div">
                <p
                  dangerouslySetInnerHTML={createMarkup(
                    messages.orignMessage,
                    customStyles
                  )}
                />
                <div className={lmoreClass}>
                  {messages.showCancelLink ? (
                    <span>
                      <button onClick={props.handleClick} type="button" style={{background: 'none', border: 'none', color: 'inherit', textDecoration: 'underline', cursor: 'pointer', padding: 0}}>
                        Never Mind
                      </button>
                      &nbsp;
                    </span>
                  ) : (
                    ""
                  )}
                  <span dangerouslySetInnerHTML={createMarkup(lmore, "")} />
                  {finalDate}
                </div>
              </div>
            </div>
          </li>
        );
      }
    } else {
      if (props.bot.cssTheme === "option2") {
        let btnMrkup = ``;
        if (
          messages.html.includes('type="qrb"') ||
          messages.html.includes('class"quick_reply"')
        ) {
          btnMrkup = createMarkup(messages.html, customStyles); // CTA style
        } else {
          const html = messages.html.replace(
            /type="button"/g,
            'type="button" style="font-weight:100;"'
          );
          btnMrkup = createMarkup(html, customStyles); // without custom styling
        }
        return (
          <li className={cName}>
            <div className="chat-image">
              <img alt={getAvatarAlt({ bot: props.bot, operators: props.operators, author })} src={avatar} onError={avatarOnError} />
            </div>
            <div className="chat-body">
              <div class="date-div">
                <div className="button-include">
                  <div className="chat-text " style={customStyles}>
                    <p
                      dangerouslySetInnerHTML={createMarkup(
                        messages.text,
                        customStyles
                      )}
                    />
                  </div>
                  <br />
                  <div className={lmoreClass}>
                    {messages.showCancelLink ? (
                      <span>
                        <button onClick={props.handleClick} type="button" style={{background: 'none', border: 'none', color: 'inherit', textDecoration: 'underline', cursor: 'pointer', padding: 0}}>
                          Never Mind
                        </button>
                        &nbsp;
                      </span>
                    ) : (
                      ""
                    )}
                    <span dangerouslySetInnerHTML={createMarkup(lmore, "")} />
                    {finalDate}
                  </div>
                  <div
                    onClick={props.handleClick}
                    className="quick_reply"
                    dangerouslySetInnerHTML={btnMrkup}
                  />
                </div>
              </div>
            </div>
          </li>
        );
      } else {
        return (
          <li className={cName}>
            <div className="chat-image">
              <img alt={getAvatarAlt({ bot: props.bot, operators: props.operators, author })} src={avatar} onError={avatarOnError} />
            </div>
            <div className="chat-body">
              <div className="button-include">
                <div className="chat-text">
                  <p
                    dangerouslySetInnerHTML={createMarkup(
                      messages.text,
                      customStyles
                    )}
                  />{" "}
                  <div className={lmoreClass}>
                    <span dangerouslySetInnerHTML={createMarkup(lmore, "")} />{" "}
                    {finalDate}
                  </div>
                </div>
                <div
                  onClick={props.handleClick}
                  className="quick_reply"
                  dangerouslySetInnerHTML={createMarkup(messages.html)}
                />
              </div>
            </div>
          </li>
        );
      }
    }
  } else return "";
};

Message.propTypes = {
  message: PropTypes.string,
  author: PropTypes.string,
  props: PropTypes.object,
  bot: PropTypes.shape({
    data: PropTypes.object,
    error: PropTypes.bool,
    fetching: PropTypes.bool,
  }),
};

export default Message;

//12 hours to add
